import styled from 'styled-components';

import { cssBreakpoints } from 'theme';

export const HeroBackgroundContainer = styled.div`
  position: absolute;
  transform: translateZ(0);
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const HeroBackgroundImageContainer = styled.div<{
  $hasMobileImage: boolean;
}>`
  width: 100%;
  height: 100%;

  ${(props) =>
    props.$hasMobileImage &&
    `
      @media all and (max-width: ${cssBreakpoints.mdDown}) {
        display: none;
      }
  `}
`;

export const HeroBackgroundMobileImageContainer = styled.div`
  width: 100%;
  height: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;
